import React, { useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ModalProvider from "./components/modal";
import ThemeModeProvider from "./global/theme/themeModeProvider";
import Dashboard from "./pages/dashboard";
import Grouping from "./pages/Grouping";
import Courses from "./pages/courses";
import Login from "./pages/login";
import DynumicPages from "./pages/dynumicPages";
import Files from "./pages/courses/files";
import Quizes from "./pages/courses/quizes";
import Lessons from "./pages/courses/lessons";
import Practices from "./pages/courses/lessons/practices";
import Questions from "./pages/courses/questions";
import Users from "./pages/users";
import Banners from "./pages/banners";
import DiscountCode from "./pages/discountCode";
import Payments from "./pages/payments";
import Comments from "./pages/comments";
import Reviews from "./pages/reviews";
import ProfileSettings from "./pages/ProfileSettings";
import Ticketing from "./pages/ticketing";
import AboutUs from "./pages/aboutUs";
import Organs from "./pages/organs";
import OrganMembers from "./pages/organs/members";
import OrganCourses from "./pages/organs/courses";

function App() {
  const [mode, setMode] = useState<"light" | "dark">("dark");
  const toggleColorMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  return (
    <ThemeModeProvider mode={mode} toggleColorMode={toggleColorMode}>
      <BrowserRouter>
        <ModalProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/profile" element={<ProfileSettings />} />

            <Route path="/" element={<Dashboard />} />
            <Route path="/categories" element={<Grouping />} />

            <Route path="/courses" element={<Courses />} />
            <Route path="courses/:course/quizes" element={<Quizes />} />
            <Route path="courses/:course/snacks" element={<Lessons />} />

            <Route path=":course/:quiz/questions" element={<Questions />} />
            <Route path=":snackId/practices" element={<Practices />} />
            <Route path="courses/:course/files" element={<Files />} />
            <Route path="/dynumic-pages" element={<DynumicPages />} />

            <Route path="/comments" element={<Comments />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/users" element={<Users />} />
            <Route path="/banners" element={<Banners />} />
            <Route path="/vouchers" element={<DiscountCode />} />
            <Route path="/organs" element={<Organs />} />
            <Route path="/organs/:organ/members" element={<OrganMembers />} />
            <Route path="/organs/:organ/courses" element={<OrganCourses />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/ticketing" element={<Ticketing />} />
            <Route path="/gettingToKnowUs" element={<AboutUs />} />
          </Routes>
        </ModalProvider>
      </BrowserRouter>
    </ThemeModeProvider>
  );
}

export default App;
